<template>
    <div :class="['maintenance-card', 'bg-dark', tipo, { 'selected': isSelected }]"
        @click="$emit('seleccionar', tipo, titulo)">
        <div class="card-icon-wrapper">
            <i class="icon">
                <component :is="iconoComponente" />
            </i>
        </div>
        <div class="card-content">
            <h3>{{ titulo }}</h3>
            <p>{{ descripcion }}</p>
        </div>
        <div class="card-footer">
            <span class="view-details">¡Ingresar información!</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cardInfo',
    props: {
        tipo: {
            type: String,
            required: true,
            validator: (value) => ['preventivo', 'correctivo', 'alistamiento', 'autorizaciones'].includes(value)
        },
        titulo: {
            type: String,
            required: true
        },
        descripcion: {
            type: String,
            required: true
        },
        selectedCard: {
            type: String,
            default: null,
        },
    },
    computed: {
        iconoComponente() {
            return {
                template: this.obtenerIconoSVG()
            };
        },
        isSelected() {
            return this.selectedCard === this.tipo;
        },
    },
    methods: {
        obtenerIconoSVG() {
            const iconos = {
                preventivo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v4"/><path d="M12 18v4"/><path d="m4.93 4.93 2.83 2.83"/><path d="m16.24 16.24 2.83 2.83"/><path d="M2 12h4"/><path d="M18 12h4"/><path d="m4.93 19.07 2.83-2.83"/><path d="m16.24 7.76 2.83-2.83"/></svg>',

                correctivo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="m4.93 4.93 14.14 14.14"/></svg>',

                alistamiento: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h1"/><path d="M17 3h1a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-1"/><path d="M12 12v9"/><path d="M8 21h8"/><path d="M4.5 9 2 11l2.5 2"/><path d="M19.5 9 22 11l-2.5 2"/></svg>',

                autorizaciones: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/><path d="M12 15v3"/></svg>'
            };

            return iconos[this.tipo] || iconos.preventivo;
        }
    }
}
</script>

<style scoped>
.maintenance-card {
    border-radius: 12px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    width: 260px;
    overflow: hidden;
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    position: relative;
    border-top: 4px solid transparent;
}

.maintenance-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.12);
}

/* Estilo para tarjeta seleccionada */
.maintenance-card.selected {
    transform: translateY(-5px);
    box-shadow: 0 12px 25px rgba(0, 0, 0, 0.2);
    border: 2px solid;
    border-top-width: 4px;
}

.preventivo.selected {
    border-color: #4CAF50;
    background-color: rgba(76, 175, 80, 0.05);
}

.correctivo.selected {
    border-color: #F44336;
    background-color: rgba(244, 67, 54, 0.05);
}

.alistamiento.selected {
    border-color: #2196F3;
    background-color: rgba(33, 150, 243, 0.05);
}

.autorizaciones.selected {
    border-color: #FF9800;
    background-color: rgba(255, 152, 0, 0.05);
}

.card-icon-wrapper {
    display: flex;
    justify-content: center;
    padding: 1.5rem 0;
}

.icon {
    width: 60px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.maintenance-card:hover .icon,
.maintenance-card.selected .icon {
    transform: scale(1.1);
}

.selected.preventivo .icon {
    background-color: #4CAF50;
    color: white;
}

.selected.correctivo .icon {
    background-color: #F44336;
    color: white;
}

.selected.alistamiento .icon {
    background-color: #2196F3;
    color: white;
}

.selected.autorizaciones .icon {
    background-color: #FF9800;
    color: white;
}

.card-content {
    padding: 0 1.5rem 1.5rem;
    flex-grow: 1;
}

.card-content h3 {
    margin: 0 0 0.75rem;
    font-size: 1.2rem;
    font-weight: 600;
}

.card-content p {
    margin: 0;
    font-size: 0.9rem;
    line-height: 1.5;
}

.card-footer {
    padding: 1rem 1.5rem;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    text-align: center;
}

.view-details {
    font-size: 0.85rem;
    font-weight: 500;
    transition: color 0.3s ease;
}

/* Estilos específicos para cada tarjeta */
.preventivo {
    border-top-color: #4CAF50;
}

.preventivo .icon {
    color: #4CAF50;
}

.preventivo:hover .icon {
    background-color: #4CAF50;
    color: white;
}

.correctivo {
    border-top-color: #F44336;
}

.correctivo .icon {
    color: #F44336;
}

.correctivo:hover .icon {
    background-color: #F44336;
    color: white;
}

.alistamiento {
    border-top-color: #2196F3;
}

.alistamiento .icon {
    color: #2196F3;
}

.alistamiento:hover .icon {
    background-color: #2196F3;
    color: white;
}

.autorizaciones {
    border-top-color: #FF9800;
}

.autorizaciones .icon {
    color: #FF9800;
}

.autorizaciones:hover .icon {
    background-color: #FF9800;
    color: white;
}

/* Responsive */
@media (max-width: 768px) {
    .maintenance-card {
        width: 100%;
        max-width: 320px;
    }
}
</style>